export default "assets/images/texture_bleu-6c645fcc.jpg";